import type { ReactNode } from "react";
import type { Nav } from "../App";
import { SyncPill } from "../App";
import type { User } from "../api";
import type { SyncState } from "../sync";
import { applyUpdate } from "../update";

export type ScreenProps = {
  nav: Nav;
  back: () => void;
  user: User;
  state: SyncState;
  onSync: () => void;
  updateReady?: boolean;
};

/** Общий каркас экрана: шапка со статусом отправки, тело, нижняя панель кнопок. */
export function Shell({
  title, onBack, state, children, footer, updateReady,
}: {
  title: string;
  onBack?: () => void;
  state: SyncState;
  children: ReactNode;
  footer?: ReactNode;
  updateReady?: boolean;
}) {
  const unsent = state.pending + state.photosPending;
  return (
    <div className="app">
      {updateReady && (
        <div className="update">
          <span>Готово обновление приложения</span>
          <button className="btn tiny" onClick={applyUpdate}>
            {unsent > 0 ? "Обновить (сначала дождитесь отправки)" : "Обновить"}
          </button>
        </div>
      )}
      <div className="bar">
        {onBack && <button className="back" onClick={onBack}>← Назад</button>}
        <h1>{title}</h1>
        <SyncPill state={state} />
      </div>
      <div className="body">{children}</div>
      {footer && <div className="foot">{footer}</div>}
    </div>
  );
}
